export default '/build/0ddff445.svg'